import * as actionTypes from "./complaintsType";

const INITIAL_STATE = {
  ComplaintsList: null,
  ComplaintsListById: {},
  ComplaintsListData: {},
  ProductCategoryList: {},
  ComplaintsCategoryList: [],
  customerList: [],
  complaintsCount: [],
  customerInvoiceList: [],
  customerItemList: [],
  ComplaintsComments: [],
  complaintAttachmentData: [],
};

const ComplaintsReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case actionTypes.SETCOMPLAINTSLIST:
      return {
        ...state,
        ComplaintsList: action.payload,
      };
    case actionTypes.SETCOMPLAINTLISTBYID:
      return {
        ...state,
        ComplaintsListById: action.payload,
      };
    case actionTypes.SETCOMPLAINTSLISTDATA:
      return {
        ...state,
        ComplaintsListData: action.payload.list.Data,
      };
    case actionTypes.SETPRODUCTCATEGORY:
      return {
        ...state,
        ProductCategoryList: action.payload.list.Data,
      };
    case actionTypes.SETCOMPLAINTSCATEGORY:
      return {
        ...state,
        ComplaintsCategoryList: action.payload,
      };
    case actionTypes.SETCUSTOMERLIST:
      return {
        ...state,
        customerList: action.payload,
      };
    case actionTypes.SETCOMPLAINTSCOUNT:
      return {
        ...state,
        complaintsCount: action.payload,
      };
    case actionTypes.SETCUSTOMERINVOICELIST:
      return {
        ...state,
        customerInvoiceList: action.payload,
      };
    case actionTypes.SETCUSTOMERITEMLIST:
      return {
        ...state,
        customerItemList: action.payload,
      };
    case actionTypes.SETCOMPLAINTSCOMMENTS:
      return {
        ...state,
        ComplaintsComments: action.payload,
      };
    case actionTypes.SETCOMPLAINTATTACHMENTDATA:
      return {
        ...state,
        complaintAttachmentData: action.payload,
      };
    default:
      return state;
  }
};

export default ComplaintsReducer;
